import { Link, useSearchParams } from "react-router-dom";

function GoogleGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="w-4 h-4" aria-hidden="true">
      <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.2-2.27H12v4.3h6.47c-.28 1.5-1.13 2.77-2.41 3.62v3h3.86c2.26-2.09 3.57-5.17 3.57-8.65z"/>
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.92l-3.86-3c-1.07.72-2.45 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.29 24 12 24z"/>
      <path fill="#FBBC05" d="M5.27 14.27A7.14 7.14 0 0 1 4.9 12c0-.79.14-1.55.37-2.27V6.64H1.29A11.94 11.94 0 0 0 0 12c0 1.93.46 3.76 1.29 5.36l3.98-3.09z"/>
      <path fill="#EA4335" d="M12 4.77c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.29 0 3.26 2.7 1.29 6.64l3.98 3.09C6.22 6.88 8.87 4.77 12 4.77z"/>
    </svg>
  );
}

function AppleGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true">
      <path d="M16.36 1.02c.1 1.05-.29 2.09-.94 2.85-.68.8-1.79 1.42-2.87 1.34-.13-1.02.32-2.09.96-2.79.71-.79 1.9-1.4 2.85-1.4zM20.5 17.2c-.5 1.1-.75 1.6-1.4 2.55-.92 1.35-2.22 3.03-3.83 3.05-1.43.02-1.8-.93-3.75-.92-1.95.01-2.35.94-3.78.92-1.6-.02-2.83-1.53-3.75-2.88C1.5 16.98.9 12.9 2.98 9.99c1.14-1.6 2.98-2.6 4.7-2.63 1.44-.02 2.36.98 3.75.98 1.35 0 2.05-.98 3.78-.95 1.5.02 3.08.83 4.2 2.26-3.7 2.13-3.1 7.28.09 8.55z"/>
    </svg>
  );
}

export default function Login() {
  const [params] = useSearchParams();
  const next = params.get("next");

  const continueWithGoogle = () => {
    if (next && next.startsWith("/")) sessionStorage.setItem("post_login_next", next);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <h1 className="font-serif-display text-4xl mb-2">Sign in</h1>
      <p className="mb-8 text-sm" style={{ color: "var(--text-secondary)" }}>
        Continue your care journey with Counseltaria&trade;.
      </p>
      <div className="card-soft p-8 space-y-4">
        <button data-testid="continue-with-google-btn" onClick={continueWithGoogle}
          className="btn-primary w-full inline-flex items-center justify-center gap-2">
          <GoogleGlyph /> Continue with Google
        </button>
        <button data-testid="continue-with-apple-btn" disabled title="Coming soon"
          className="btn-outline w-full inline-flex items-center justify-center gap-2 opacity-50 cursor-not-allowed">
          <AppleGlyph /> Continue with Apple <span className="text-xs">(coming soon)</span>
        </button>
        <p className="text-xs text-center pt-2" style={{ color: "var(--text-secondary)" }}>
          Clients, counsellors and team members all sign in the same way — no separate
          password to create or remember.
        </p>
      </div>
      <p className="text-xs text-center mt-8">
        <Link data-testid="admin-login-link" to="/admin-login" className="underline"
          style={{ color: "var(--text-secondary)" }}>
          Admin sign in
        </Link>
      </p>
    </div>
  );
}
